// extracted by mini-css-extract-plugin
export default {"modalContent":"new-caption-modal_modalContent__KZUwv","modalInputGroup":"new-caption-modal_modalInputGroup__zDN+t","captionDropzone":"new-caption-modal_captionDropzone__YbOBf"};